import { render } from "./SearchForm.vue?vue&type=template&id=3da6d621&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=3da6d621&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3da6d621"

export default script